import React, {Component, PureComponent} from 'react';
import PropTypes from 'prop-types';
import Interior360Item from '../../blocks/interior360-item';
import './styles.css';

/**
 *  Interior360
 */
class Interior360Items extends Component {
  static propTypes = {
    currentItemIndex: PropTypes.number,
    items: PropTypes.arrayOf(PropTypes.node),
    isMultipleLines: PropTypes.bool,
    isSingleLines: PropTypes.bool,
    onChangeItem: PropTypes.func,
    isViewIcons: PropTypes.bool,
  };
  static defaultProps = {
    currentItemIndex: 0,
    items: [],
    isMultipleLines: false,
    isSingleLines: false,
    onChangeItem: null,
    isViewIcons: true,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    this.state = {
      hoverItemIndex: 0,
      isScrollEnabled: false,
    };
    //
    this._intervalId = null;
    this._intervalId2 = null;
    this._items = React.createRef();
  }

  componentDidMount() {
    // アイテムをスクロールさせるか
    if (this._intervalId) clearInterval(this._intervalId);
    this._intervalId = setInterval(()=> {
      this.checkScrollEnabled();
    }, 200);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // SPでタブを切り替えても、サムネイルのスクロール位置が初期化されない
    if (this.props.items !== nextProps.items) {
      if (this._intervalId2) clearInterval(this._intervalId2);
      if (this._items && this._items.current) {
        this._items.current.scrollLeft = 0;
      }
    }
    // // SPでタブを切り替えても、サムネイルのスクロール位置が初期化されない
    // if (this.props.currentItemIndex !== nextProps.currentItemIndex) {
    //   if (nextProps.currentItemIndex === 0) {
    //     if (this._intervalId2) clearInterval(this._intervalId2);
    //     this._items.current.scrollLeft = 0;
    //   }
    // }
    return true;
  }

  // アイテム変更
  changeItem = (index)=> {
    // スクロール
    if (this._items.current) {
      const easing = (t, b, c, d) => {
        return c * ((t = t / d - 1) * t * t + 1) + b;
      }
      let time = 0;
      const target = ((index * 65) + 5) - ((this._items.current.clientWidth - 30) / 2) + 25;
      const current = this._items.current.scrollLeft;
      const sub = target - current;
      if (this._intervalId2) clearInterval(this._intervalId2);
      this._intervalId2 = setInterval(()=> {
        time = time + (1 / 30) * 2;
        // time = time + (1 / 60) * 2;
        if (1 < time) {
          clearInterval(this._intervalId2);
        } else {
          this._items.current.scrollLeft = current + (easing(time, 0, 1, 1) * sub);
        }
      }, 1000 / 30)
    }

    // イメージ変更
    this.props.onChangeItem(index);
  }

  // アイテムをスクロールさせるか
  checkScrollEnabled = ()=> {
    if (this._items.current) {
      if (this._items.current.clientWidth - 35 < (this.props.items.length * 65) - 15) {
        this.setState({
          isScrollEnabled: true,
        })
      } else {
        this.setState({
          isScrollEnabled: false,
        })
      }
    }
  }

  render() {
    const {
      currentItemIndex,
      items,
      isMultipleLines,
      isSingleLines,
      isViewIcons,
    } = this.props;

    // アイテム表示
    const renderItems = () => {
      if (!isViewIcons) return null;
      return (
        <div className="Interior360__items opened">
          <ul className={'Interior360__items__list' + (this.state.isScrollEnabled ? ' scrollEnabled' : '')} ref={this._items}>
            {items.map((child, index) => {
              return (
                <li key={index}>
                  <Interior360Item {...child.props}
                    index={index}
                    onMouseOver={(e)=> {
                      this.setState({
                        hoverItemIndex: e,
                      })
                    }}
                    onMouseOut={(e)=> {
                      this.setState({
                        hoverItemIndex: null,
                      })
                    }}
                    onClick={(e)=> {
                      // アイテム変更
                      this.changeItem(e);
                    }}
                    isCurrent={(index === currentItemIndex)}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      )
    }

    // インテリア名表示
    const renderInteriorName = () => {
      let data = null;
      if (null !== this.state.hoverItemIndex) {
        data = items[this.state.hoverItemIndex].props;
      } else {
        data = items[currentItemIndex].props
      }
      const getPcInteriorName = () => {
        if (data.pcInteriorName && data.pcInteriorName !== '') {
          return data.pcInteriorName.replace(/[|]/g, '<br>');
        } else {
          return null;
        }
      };
      const getMbInteriorName = () => {
        if (data.mbInteriorName && data.mbInteriorName !== '') {
          return data.mbInteriorName.replace(/[|]/g, '<br>');
        } else {
          return getPcInteriorName();
        }
      };
      return (
        <p className={'Interior360__interior-name' + (isMultipleLines ? ' multiline' : '') + (isSingleLines ? ' singleline' : '')}>
          <span className="pc" dangerouslySetInnerHTML={{__html: getPcInteriorName()}} />
          <span className="mb" dangerouslySetInnerHTML={{__html: getMbInteriorName()}} />
        </p>
      )
    }

    return (
      <div>
        {renderItems()}
        {renderInteriorName()}
      </div>
    )
  }

}

export default Interior360Items;



// WEBPACK FOOTER //
// ./src/containers/interior360/Interior360Items.jsx